import React from 'react';
import styles from './ToggleField.module.css';

export interface ToggleFieldProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  hint?: string;
  disabled?: boolean;
  /** Toggle rows read best on their own line; set false to keep one inside a single grid column. */
  fullWidth?: boolean;
}

export const ToggleField: React.FC<ToggleFieldProps> = ({
  label,
  checked,
  onChange,
  hint,
  disabled = false,
  fullWidth = true,
}) => {
  const className = [
    styles.row,
    fullWidth ? styles.fullWidth : '',
    disabled ? styles.disabled : '',
  ].filter(Boolean).join(' ');

  return (
    <label className={className}>
      <span className={styles.text}>
        <span className={styles.label}>{label}</span>
        {hint ? <span className={styles.hint}>{hint}</span> : null}
      </span>
      <span className={styles.switch}>
        <input
          type="checkbox"
          className={styles.input}
          checked={checked}
          disabled={disabled}
          onChange={event => onChange(event.target.checked)}
        />
        <span className={styles.slider} aria-hidden="true" />
      </span>
    </label>
  );
};
